export const DEFAULT_SNAPSHOT_ID = 'default';
